import convertUnicodeToEmoji from"./convertUnicodeToEmoji.js";import emojiList from"./emojiList.js";var getGroupEmojis=function(category){return emojiList[category].map((function(unicode){return convertUnicodeToEmoji(unicode)}))};export{getGroupEmojis as default};
//# sourceMappingURL=getGroupEmojis.js.map
